import {
  Datagrid,
  EditButton,
  Filter,
  List,
  TextField,
  TextInput,
} from 'react-admin';
import ListPagination from '../ListPagination';
import ListViewTopToolbar from '../ListViewTopToolbar';

const LocaleFilter = (props: any) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <Filter {...props}>
    <TextInput
      label="settings.search"
      source="name_or_key_or_direction_cont"
      alwaysOn
      translate="yes"
    />
  </Filter>
);

const LocaleList = (props: any) => (
  <List
    exporter={false}
    filters={<LocaleFilter />}
    pagination={<ListPagination />}
    perPage={50}
    actions={<ListViewTopToolbar />}
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...props}
  >
    <Datagrid rowClick="edit">
      <TextField source="name" />
      <TextField source="key" />
      <TextField source="direction" />
      <EditButton className="text-list-button" />
    </Datagrid>
  </List>
);

export default LocaleList;
